import _ from 'lodash';

import { HistoryState } from 'types';
import AppConstants from 'constants/AppConstants';

const initialState: HistoryState = {
  locationHistory: [],
};

export default function reducer(
  state: HistoryState = initialState,
  action: BaseTockAction
): HistoryState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.HISTORY_LOCATION_PUSH: {
      // Max out our history tracking at 300
      const locationHistory = _.slice([payload, ...state.locationHistory], 0, 300);
      return {
        ...state,
        locationHistory,
      };
    }
    case AppConstants.HISTORY_LOCATION_REPLACE: {
      const locationHistory = [payload, ..._.tail(state.locationHistory)];
      return {
        ...state,
        locationHistory,
      };
    }
    case AppConstants.HISTORY_LOCATION_BACK: {
      const locationHistory = _.tail(state.locationHistory);
      return {
        ...state,
        locationHistory,
      };
    }
    default:
      return state;
  }
}
